module.exports = __webpack_public_path__ + "img/cricket.2a0afb97.svg";